import jsCookie from "js-cookie";
import { http, $http } from "@/utils/http";
import { report } from "@/utils/reportError";

/**
 * 查询账号管理的门店
 * @typedef {Object} storeInfo
 * @property {string} businessId
 * @property {string} storeId
 * @property {string} storeName
 * @returns {Promise<{storeList:storeInfo[],toStore:boolean}>}
 */
export async function getStoreList() {
  const accountID = jsCookie.get("buzzCode");
  try {
    const res = await http.get(
      `//scbapi.haiziwang.com/scb-api/store/queryStoreByAccount.do?account=${accountID}`
    );
    if (+res.code === 1) {
      return res.data;
    }
    console.error(res);
    return {};
  } catch (error) {
    throw error;
  }
}

/**
 * 查询核销码状态
 * @param {string} barcode
 * @returns {Promise<{code,data:{
 *    storeList:storeInfo[],
 *    orderId,
 *    spuName,
 *    userMobile,
 *    useStartTime,
 *    useEndTime,
 *    sumNum,
 *    spNum,
 *    skuNum,
 *    barcodeState,
 *    barcode,
 *    businessId,
 *    barcodePrice,
 *    writeoffTime,
 * },msg}>}
 */
export async function queryBarcodeState(barcode) {
  const bid = jsCookie.get("buzzId");
  const url = `//scaterpapi.haiziwang.com/scaterp-api/caterp/queryOrderByBarcode4Yuer.do?barcode=${barcode}&bid=${bid}`;
  try {
    const res = await $http.get(url);
    if (+res.code === 1) {
      return res;
    } else {
      !res.report &&
        report({
          url,
          res,
          msg: res.msg || "大服务工作台根据消费码获取订单接口异常"
        });
      return res;
    }
  } catch (error) {
    throw error;
  }
}

export async function confirmConsumer4Yuer({ code, writeoffNum, storeCode }) {
  const bid = jsCookie.get("buzzId");
  const serviceCode = jsCookie.get("buzzCode");
  const url = `//scaterpapi.haiziwang.com/scaterp-api/caterp/confirmConsumer4Yuer.do?item_codes=${code}&bid=${bid}&writeoffNum=${writeoffNum}&serviceCode=${serviceCode}&storeCode=${storeCode}`;
  try {
    const res = await $http.get(url);
    return res;
  } catch (error) {
    throw error;
  }
}
